import { businessInsightsService } from "../../../services/api/business-insights.endpoint";
import {
  setBusinessInsightsList,
  setDailyAverage,
  setImpressionShare1,
  setImpressionShare2,
  setKeywordPerformance,
  setNewSearchTerms,
  setTaskDetails,
} from "../../../features/businessInsightsSlice";
import store from "../../../store";
import {
  setAllUsers,
  setDisplayErrorSnackBar,
} from "../../../features/userSlice";

async function getAllBusinessInsights(
  selectedSharedUid: any,
  oauthTokenHeader: string,
  dispatch: any
) {
  try {
    const response = await businessInsightsService.getAllBusinessInsightsList(
      oauthTokenHeader,
      selectedSharedUid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get business insights list");
    } else {
      dispatch(setBusinessInsightsList(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getTaskDetails(oauthTokenHeader: any, taskSharedUid: any) {
  try {
    const response = await businessInsightsService.getTaskDetails(
      oauthTokenHeader,
      taskSharedUid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get task details");
    } else {
      store.dispatch(setTaskDetails(response?.data?.data));
      return response?.data; // Return the response
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getKeywordsPerformance(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  adgroupId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getKeywordsPerformance(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      adgroupId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get keywords performance");
    } else {
      store.dispatch(setKeywordPerformance(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getKeywordsPerformanceCampaign(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  campaignId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response =
      await businessInsightsService.getKeywordsPerformanceCampaign(
        oauthTokenHeader,
        QUERY_ID,
        websiteSharedUid,
        campaignId,
        startDate,
        endDate,
        type
      );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get keywords performance");
    } else {
      store.dispatch(setKeywordPerformance(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getNewSearchTerms(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  adgroupId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getNewSearchTerms(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      adgroupId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get new search terms");
    } else {
      store.dispatch(setNewSearchTerms(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getNewSearchTermsCampaign(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  campaignId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getNewSearchTermsCampaign(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      campaignId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get new search terms");
    } else {
      store.dispatch(setNewSearchTerms(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getImpressionShare1(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  adgroupId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getImpressionShare1(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      adgroupId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get impression share");
    } else {
      store.dispatch(setImpressionShare1(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getImpressionShare1Campaign(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  campaignId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getImpressionShare1Campaign(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      campaignId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get impression share");
    } else {
      store.dispatch(setImpressionShare1(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getImpressionShare2(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  adgroupId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getImpressionShare2(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      adgroupId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get impression share");
    } else {
      store.dispatch(setImpressionShare2(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getImpressionShare2Campaign(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  campaignId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getImpressionShare2Campaign(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      campaignId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get impression share");
    } else {
      store.dispatch(setImpressionShare2(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getDailyAverage(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  adgroupId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getDailyAverage(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      adgroupId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get daily average query");
    } else {
      store.dispatch(setDailyAverage(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getDailyAverageCampaign(
  oauthTokenHeader: any,
  QUERY_ID: any,
  websiteSharedUid: any,
  campaignId: any,
  startDate: string,
  endDate: string,
  type: string
) {
  try {
    const response = await businessInsightsService.getDailyAverageCampaign(
      oauthTokenHeader,
      QUERY_ID,
      websiteSharedUid,
      campaignId,
      startDate,
      endDate,
      type
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get daily average query");
    } else {
      store.dispatch(setDailyAverage(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function changeInsightTaskStatus(oauthTokenHeader: any, data: any) {
  try {
    const response = await businessInsightsService.updateInsightTaskStatus(
      oauthTokenHeader,
      data
    );
    if (!response || !response.status) {
      throw new Error("Failed to update the task. Please try again later.");
    } else if (response.status === 207 || response.status === 200) {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Current status has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    const message = { reason: "Unknown error occurred." }; // custom message for error handling
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    return e ? e?.parsedText : message;
  }
}

async function postCommentBusinessInsightTask(
  oauthTokenHeader: any,
  data: any,
  objectSharedUid: any
) {
  try {
    const response = await businessInsightsService.postComment(
      oauthTokenHeader,
      data,
      objectSharedUid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to post comment action items");
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Comment has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getCommentsForBusinessInsight(
  oauthTokenHeader: any,
  object_shared_uid: any,
  setComments: any
) {
  try {
    const response = await businessInsightsService.getComments(
      oauthTokenHeader,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setComments([]);
      throw new Error("Failed to get comments for specific task");
    }else if(response.status === 200){
      const comments = Object.values(response?.data?.data)[0] || [];
      setComments(comments);
    }
  } catch (e: any) {
    console.error(e);
  }
}

async function putCommentsForBusinessInsight(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await businessInsightsService.putComments(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to edit comments");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getFiles(
  oauthTokenHeader: any,
  object_shared_uid: any,
  setFiles: any
) {
  try {
    const response = await businessInsightsService.getFiles(
      oauthTokenHeader,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setFiles([]);
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
    }
  } catch (e: any) {
    console.error(e);
  }
}

async function uploadFile(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await businessInsightsService.uploadFile(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await businessInsightsService.getAllUsers(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function assignBussinessInsights(
  oauthTokenHeader: any,
  data: any,
  taskSharedUid: any
) {
  try {
    const response = await businessInsightsService.assignBussinessInsights(
      oauthTokenHeader,
      data,
      taskSharedUid
    );
    if (!response || !response.status || response.status !== 207) {
      throw new Error("Failed to assign business insights");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function resolveBusinessInsightsStatus(
  oauthTokenHeader: any,
  data: any,
  taskSharedUid: any
) {
  try {
    const response =
      await businessInsightsService.resolveBusinessInsightsStatus(
        oauthTokenHeader,
        data,
        taskSharedUid
      );
    if (!response || !response.status || response.status !== 207) {
      throw new Error("Failed to resolve business insights");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function updateBusinessInsightsStatus(
  oauthTokenHeader: any,
  data: any,
  taskSharedUid: any
) {
  try {
    const response = await businessInsightsService.updateBusinessInsightsStatus(
      oauthTokenHeader,
      data,
      taskSharedUid
    );
    if (!response || !response.status || response.status !== 207) {
      throw new Error("Failed to update business insights status");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function CreateNewActionItem(oauthTokenHeader: string, data: any) {
  try {
    const response = await businessInsightsService.createNewTask(
      oauthTokenHeader,
      data
    );
    if (!response || !response.status) {
      // Ensure response exists and check for both 200 and 201
      return { reason: "Failed to create new task." };
    }
    if (response.status === 200) {
      return response?.data;
    } else if (response.status === 201) {
      return response?.data;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    return e?.parsedText || { reason: "Unknown error occurred." };
  }
}

// delete comment of business insights
async function deleteCommentForBusinessInsight(
  oauthTokenHeader: any,
  object_shared_uid: any,
  comment_shared_uid: any
) {
  try {
    const response = await businessInsightsService.deleteComment(
      oauthTokenHeader,
      object_shared_uid,
      comment_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete comments");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

// delete file of business insights
async function deleteFileForBusinessInsight(
  oauthTokenHeader: any,
  file_shared_uid: any
) {
  try {
    const response = await businessInsightsService.deleteFile(
      oauthTokenHeader,
      file_shared_uid
    );
    if (!response || !response.status) {
      throw new Error("Failed to delete file");
      // according to the API documentation, it returns 204 for successful deletion
    } else if (response.status === 204) {
      //response?.data as returns null when file is deleted successfully
      // This is a success case, so we can return a custom success message 
     // let sucessMsg = { reason: "Success." }; // Set a success message
      return response?.data; 
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}




export const BusinessInsightsEndPointLogic = {
  getAllBusinessInsights,
  getKeywordsPerformance,
  getKeywordsPerformanceCampaign,
  getNewSearchTerms,
  getNewSearchTermsCampaign,
  getImpressionShare1,
  getImpressionShare1Campaign,
  getImpressionShare2,
  getImpressionShare2Campaign,
  getDailyAverage,
  getDailyAverageCampaign,
  getTaskDetails,
  changeInsightTaskStatus,
  postCommentBusinessInsightTask,
  getCommentsForBusinessInsight,
  putCommentsForBusinessInsight,
  getFiles,
  uploadFile,
  getAllUserList,
  assignBussinessInsights,
  resolveBusinessInsightsStatus,
  updateBusinessInsightsStatus,
  CreateNewActionItem,
  deleteCommentForBusinessInsight,
  deleteFileForBusinessInsight
};
